import EventBus from './eventbus';

const setup = eventName => ({
  emit: data => EventBus.$emit(eventName, data),
  on: cb => EventBus.$on(eventName, cb),
  off: cb => EventBus.$off(eventName, cb),
});

export const cartSynced = setup('Cart Synced');
